import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  search: {
    textAlign: "right",
  },
  root: {
    margin: theme.spacing(1),
  },
  button: {
    padding: "0px 5px 0px 5px",
    marginLeft: theme.spacing(1),
  },
  addKeyword: {
    marginTop: theme.spacing(2),
    height: 30,
  },
  cardContent: {
    padding: "5px 0px 0px 5px",
  },
  cardAction: {
    paddingInlineEnd: 1,
  },
}));

export default useStyles;
